module.exports = __webpack_public_path__ + "img/logo-cropped.4ec4ea44.png";